

export enum EventName {
    APPLY_LOAN_DOCUMENTS = "Apply Loan Documents",
    KYC_DOCUMENTS = "Kyc Documents",
}

export const updateDocumentEvent = (docName: string, isUploaded: boolean) => {
    docName = removeUnderscoreAndCapitalizeFirstLetter(docName);
};

const removeUnderscoreAndCapitalizeFirstLetter = (value) => {
    return value.split("_").map((str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).join(" ");
};

export const KycDocUploadEvent = (docName: string, subDocName: string, isSuccess) => {
    docName = removeUnderscoreAndCapitalizeFirstLetter(docName);
};
